<div class="card">
    <div class="card-body" *ngIf="!loginExpired">
        <div class="text-center">
            <i class="ki-outline ki-information-5 text-warning fs-3hx"></i>
        </div>
        <h3 class="text-center">We'll sign you out in
            <!-- {{sessionService?.remainingSessHours}}:{{sessionService?.remainingSessMinutes-1}}:{{sessionService?.remainingSessSeconds}} -->
        </h3>
        <countdown #cd [config]="config" (event)="handleEvent($event)" class="custom-style" />
        <br>
        <p class="text-center">Auto logout after 5 minutes of inactivity.</p>
        <hr class="mt-5">
        <a href="javascript:void(0)" (click)="refreshToken()" class="btn btn-success btn-sm float-start">Extend time</a>
        <a href="javascript:void(0)" (click)="logout()" class="btn btn-danger btn-sm float-end">Sign
            out</a>
    </div>
    <div class="card-body" *ngIf="loginExpired">
        <div class="text-center">
            <i class="ki-outline ki-information-5 text-warning fs-3hx"></i>
        </div>
        <h3 class="text-center">Session expired!</h3>
        <hr class="mt-5">
        <a href="javascript:void(0)" (click)="logout()" class="btn btn-danger btn-sm float-end">Close</a>
    </div>
</div>